<!-- 选择导师类型 -->
<template>
  <div class="apply-select">
    <div class="apply-select-con">
      <img :src="logo"
           alt="">
      <p>Please click your role below to proceed</p>
      <ul v-show="isData">
        <li @click="linkHandle('sm')"
            v-if="mentorType.smcmProgress !== 2">School / Career Mentor</li>
        <li @click="linkHandle('em')"
            v-if="mentorType.emProgress !== 2">Editor Mentor</li>
      </ul>
      <a @click="handleBack">Back</a>
    </div>
    <div class="apply-bottom-copy" v-html="copyright"></div>
  </div>
</template>
<script>
// api
import { getApplyIds } from '@/api/talents'
// images
import logo from '@/assets/Logo.svg'
import { copyright } from '@/constant'
export default {
  name: 'apply-mentor-select',
  components: {},
  data () {
    return {
      logo,
      copyright,
      mentorType: {},
      prePageName: '',
      isData: false
    }
  },
  computed: {},
  mounted () {
    // 获取导师类型
    this.getMentorType()
  },
  methods: {
    getMentorType () {
      getApplyIds({}).then(res => {
        this.isData = true
        this.mentorType = res.data.result
      })
    },
    linkHandle (type) {
      this.$router.push({
        name: type
      })
    },
    // 返回上一页
    handleBack () {
      let name = this.prePageName
      if (name === 'register') {
        this.$router.push({
          name: 'apply-banner'
        })
      } else {
        this.$router.go(-1)
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    window.document.body.style.background = '#fff'
    window.document.body.className = 'hide-home'
    next(vm => {
      if (from.matched.some(({ name }) => name === 'register')) {
        vm.prePageName = 'register'
      } else {
        vm.prePageName = ''
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    window.document.body.style.background = ''
    window.document.body.className = ''
    next()
  }
}
</script>
<style lang='less' scoped>
</style>
